"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    loanProductSlug: zod_1.z.string().optional().describe('Loan product slug'),
    creditFacilitySlug: zod_1.z
        .string()
        .optional()
        .describe('If you are referencing a table that is part of a credit facility, you can specify the credit facility slug here.'),
    query: zod_1.z.string().describe('Query to execute.'),
    bindings: zod_1.z
        .array(zod_1.z.string())
        .describe('Bindings to use in the query. These are formulas (if starting with =) that are evaluated to get the final value. Any placeholders (?) in the query will be replaced with these bindings.'),
});
exports.nodeType = 'file_dataLakeTape';
// loanProductSlug/creditFacilitySlug live in the artifact's columns, not in
// its configuration.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    loanProductSlug: true,
    creditFacilitySlug: true,
});
exports.artifactType = 'dataLakeTape';
//# sourceMappingURL=types.js.map